// store/reloadSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isReload: false
};

const reloadSlice = createSlice({
  name: 'reload',
  initialState,
  reducers: {
    setReload: (state, action) => {
      state.isReload = action.payload; // true or false
    },
    toggleReload: (state) => {
      state.isReload = !state.isReload; // optional: toggle
    }
  }
});

export const { setReload, toggleReload } = reloadSlice.actions;
export default reloadSlice.reducer;
